import React from "react";
import contactback from "./wave contact.svg";
const Otp = () => {
  return (
    <div>
      <img src={contactback} alt="" />
      
    </div>
  );
};

export default Otp;
